import { render, staticRenderFns } from "./ResultDescription.vue?vue&type=template&id=307eb267&scoped=true&"
import script from "./ResultDescription.vue?vue&type=script&lang=ts&"
export * from "./ResultDescription.vue?vue&type=script&lang=ts&"
import style0 from "./ResultDescription.vue?vue&type=style&index=0&id=307eb267&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307eb267",
  null
  
)

export default component.exports